import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ProductList from ".";
import ProductCategory from "../ProductCategory";
import ProductTags from "../ProductTags";
import ManageProduct from "../../../../../components/sections/admin/Product/ManageProduct";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-brands fa-product-hunt",
    path: "/admin/products",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/product-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/products-tags",
  },
];

export const productRoutes = () => [
  {
    path: "/admin/products",
    component: () => (
      <TabsNavigation title="Products Management" tabRoutes={tabRoutes}>
        <ProductList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Products Management",
  },
  {
    path: "/admin/product-categories",
    component: () => (
      <TabsNavigation title="Products Management" tabRoutes={tabRoutes}>
        <ProductCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Products Management",
  },
  {
    path: "/admin/products-tags",
    component: () => (
      <TabsNavigation title="Products Management" tabRoutes={tabRoutes}>
        <ProductTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Products Management",
  },
  {
    path: "/admin/manage-products",
    component: ManageProduct,
    layout: "admin",
    routeType: "admin",
    title: "Manage Products",
  },
  {
    path: `/admin/manage-products/:id`,
    component: ManageProduct,
    layout: "admin",
    routeType: "admin",
    title: "Manage Products",
  },
];
